import { NgModule } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ToasterComponent } from './toaster.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ToasterComponent],
  imports: [CommonModule, ToastModule],
  exports: [ToasterComponent],
})
export class ToasterComponentModule {}
